import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  subtitle?: string;
};

export default function SectionHeader({ title, subtitle }: Props) {
  return (
    <Box mb="lg">
      <Text size="displayXs" fw={FONT_WEIGHTS.semibold}>
        {title}
      </Text>
      {subtitle && (
        <Text size="textMd" fw={FONT_WEIGHTS.medium} mt="xxxs" c="gray.6">
          {subtitle}
        </Text>
      )}
    </Box>
  );
}
